import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLoginQuery, popLastPath, useUserInfoQuery } from '../react-queries/queries';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #888;
  cursor: pointer;
  z-index: 10;
`;

const Box = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px 32px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.4;
`;

const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 14px 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 16px;
  background: #fafafa;
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 14px 0;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 8px;
  cursor: pointer;

  &:disabled {
    background: #bdbdbd;
    cursor: not-allowed;
  }
`;

const SignupLink = styled.div`
  margin-top: 20px;
  text-align: center;
  color: #666;
  cursor: pointer;
  text-decoration: underline;
`;

const LoginFormPage: React.FC<{isWebview:boolean}> = ({isWebview}) => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [loginPw, setLoginPw] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [shouldLogin, setShouldLogin] = useState(false);

  const { data: login, isLoading: queryLoading, error } = useLoginQuery(
    loginId, 
    loginPw, 
    { enabled: shouldLogin }
  );

  const { refetch: refetchUserInfo } = useUserInfoQuery();

  React.useEffect(() => {
    if (shouldLogin) {
      if (error) {
        alert('로그인 실패: ' + error.message);
        setIsLoading(false);
        setShouldLogin(false);
      } else if (login?.accessToken) {
        //alert('LoginFormPage: login: ' + JSON.stringify(login));
        refetchUserInfo();
        const lastPath = popLastPath();
        if(lastPath){
          //alert('lastPath: ' + lastPath);
          setTimeout(() => {
            navigate(lastPath, { replace: true });
          }, 1000);
        } else {
          setTimeout(() => {
            navigate('/home', { replace: true });
          }, 1000);
        }
        //navigate('/home');
        setIsLoading(false);
        setShouldLogin(false);
      }
    }
  }, [shouldLogin, login, error, navigate]);

  const handleLogin = () => {
    if (loginId && loginPw) {
      setIsLoading(true);
      setShouldLogin(true);
    }
  };

  const handleClose = () => {
    navigate('/login');
  };

  return (
    <Wrapper>
      <Box>
        <CloseButton onClick={handleClose} aria-label="닫기">×</CloseButton>
        <Title>로그인</Title>
        <Input
          type="text"
          placeholder="아이디"
          value={loginId}
          onChange={e => setLoginId(e.target.value)}
        />
        <Input
          type="password"
          placeholder="비밀번호"
          value={loginPw}
          onChange={e => setLoginPw(e.target.value)}
        />
        <LoginButton 
          onClick={handleLogin}
          disabled={!loginId || !loginPw || isLoading}
        >
          {isLoading ? '로그인 중...' : '로그인'}
        </LoginButton>
        <SignupLink onClick={() => navigate('/signup')}>
          가입하기
        </SignupLink>
      </Box>
    </Wrapper>
  );
};

export default LoginFormPage; 